/**
 * The zoom ladder — 20.2.3's viewer, where the design shows a minus, a percentage and a plus.
 *
 * Steps rather than a free scale: the two buttons have to land somewhere predictable, and a reader
 * who has zoomed in and out should arrive back at 100% exactly rather than near it. 100 is where
 * every document opens, which for a PDF means the page at its own size.
 */
export const ZOOM_STEPS = [50, 75, 100, 125, 150, 200, 300, 400] as const;

export const DEFAULT_ZOOM = 100;

export const zoomIn = (zoom: number): number =>
  ZOOM_STEPS.find((step) => step > zoom) ?? ZOOM_STEPS[ZOOM_STEPS.length - 1];

export const zoomOut = (zoom: number): number =>
  [...ZOOM_STEPS].reverse().find((step) => step < zoom) ?? ZOOM_STEPS[0];

export const canZoomIn = (zoom: number): boolean => zoom < ZOOM_STEPS[ZOOM_STEPS.length - 1];

export const canZoomOut = (zoom: number): boolean => zoom > ZOOM_STEPS[0];
